import {Component, OnInit, ViewChild} from '@angular/core';
import {SenderService} from '../../../../../services/sender.service';
import {NgxModalDraggableDirective} from '../../../../../directives/draggable.directive';
import {BsModalRef} from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-faq-parse',
  templateUrl: './faq-parse.component.html',
  styleUrls: ['./faq-parse.component.scss']
})
export class FaqParseComponent implements OnInit {

  public modalDirective: NgxModalDraggableDirective;
  @ViewChild(NgxModalDraggableDirective)
  set setDirective(directive: NgxModalDraggableDirective) {
    this.modalDirective = directive;
  }
  constructor(
    public senderService: SenderService,
    public bsModalRef: BsModalRef
  ) { }

  ngOnInit(): void {
  }

}
